import { SC } from '../helper/ServerCall';
import { pathSegment } from '../helper/queryString';

export const roleService = {
    getUserRoles,
    getAgencyRoles,
    getRolesPagination,
    storeRole,
    getRole,
    editRole,
    deleteRole,
}

function getUserRoles() {
    return SC.getCall('getUserRoles');
}

function getAgencyRoles() {
    return SC.getCall('getAgencyRoles');
}
function getRolesPagination(page, filter, sort, pageSize) {
    return SC.getCall('roles', { page, filter, sort, pageSize });
}
function storeRole(roleData) {
    return SC.postCall('roles', roleData);
}
function getRole(roleId) {
    return SC.getCall(`roles/${pathSegment(roleId)}`);
}
function editRole(roleData, roleId) {
    return SC.putCall(`roles/${pathSegment(roleId)}`, roleData);
}
function deleteRole(roleId) {
    return SC.deleteCall(`roles/${pathSegment(roleId)}`);
}
